import { CompanySettings } from "@elton/types";
import { getServicesClient } from "@/api/clients/api-client.ts";

export const updateCompanySettings = async (
  companyId: string,
  companySettings: CompanySettings,
): Promise<CompanySettings> => {
  const res = await getServicesClient().put(`/companies/${companyId}/settings`, {
    regNumberField: companySettings.regNumberField,
    noteField: companySettings.noteField,
    invoiceSpecification: companySettings.invoiceSpecification,
  });

  return res.data;
};
